import { Content } from "pdfmake/interfaces";
import { area, date, loc, polygon } from "report/common/icon";
import getTitle from "report/common/title";
import { ReportInfoParams } from "./types";

/**
 * 报告详情块
 * 生成报告左列的形状名称、面积、报告日期表格
 */
const getReportInfo = (
  t: any,
  { polygonName, polygonArea }: ReportInfoParams
): Content[] => [
  getTitle(t("report.Report Details")),
  {
    columns: [
      {
        width: "50%",
        table: {
          headerRows: 0,
          widths: ["auto", "*", "*"],
          body: [
            [
              { svg: polygon, width: 7.5, alignment: "right" },
              { text: t("report.Shape Name"), opacity: 0.6 },
              { text: polygonName }
            ],
            [
              { svg: area, width: 7.5, alignment: "right" },
              { text: t("report.Area"), opacity: 0.6 },
              { text: polygonArea }
            ],
            [
              { image: date, width: 7.5, alignment: "right" },
              { text: t("report.Report Date"), opacity: 0.6 },
              {
                text: new Date().toLocaleString("zh-CN", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit"
                })
              }
            ]
          ]
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0,
          hLineColor: () => "#F0F0F0",
          paddingTop: () => 3,
          paddingBottom: () => 3
        },
        fontSize: 8
      },
      { width: "*", text: "" }
    ]
  }
];

export default getReportInfo;
